<template>
    <div>
        <main>
            <CxPoliticaPrivacidad />
        </main>
    </div>
</template>
  
<script>

import CxPoliticaPrivacidad from '@/components/CxPoliticaPrivacidad.vue';

export default {
    components: {
        CxPoliticaPrivacidad
    }
}
</script>
  
<style scoped></style>